import { DeveloperSettings } from './DeveloperSettings';

export default DeveloperSettings;
